define('appkit/app',[
  'backbone',
  'underscore',

  './router',

  './model/page.state',
  './controller.registry',
  './singleton.registry',

  'datakit/ajax',
  'backbone.radio'
], function(
  Backbone,
  _,
  AKRouter,
  PageState,
  ControllerRegistry,
  SingletonRegistry,
  AJAX,
  Radio
) {

  var App = function(options) {
    _.extend(this, options);
    // register a global route handler
    Backbone.history.on('route', this.onGlobalRoute, this);
    // initialize the app channels
    this._initChannel();
    // create a new default controller registry
    // must happen AFTER the channel is init
    this.controllerRegistry = new ControllerRegistry(this, null, this.routingChannelName);
    // unless disable ajax is specified
    // then enable ajax
    if (this.disableAjax !== true) {
      AJAX.enable();
    }
    this.initialize.apply(this, arguments);
    // add the app channel so singleton events will get triggered
    // on the app channel
    SingletonRegistry.addEventBus(this.channel);
  };

  App.extend = Backbone.View.extend;

  _.extend(App.prototype, Backbone.Events, {

    serviceSuffix: ':service',

    initialize: function() {

    },

    get: function(name) {
      return this.getSingleton.apply(this, arguments);
    },

    getSingleton: function(name) {
      return SingletonRegistry.get(name);
    },

    addConfigurator: function(Configurator, args) {
      args = _.isArray(args) ? args : [];
      var configurator = this.buildConfigurator(Configurator);
      configurator.configure.apply(configurator, args);
      return this;
    },

    register: function(name, instance) {
      if (_.isObject(name)) {
        _.each(name, function(inst, name) {
          this.registerSingleton(name, inst);
        }, this);
      } else {
        this.registerSingleton.apply(this, arguments);
      }
      return this;
    },

    registerSingleton: function(name, instance) {
      SingletonRegistry.register(name, instance);
      return this;
    },

    registerService: function(name, Service) {
      var service = this.buildService(Service);
      SingletonRegistry.register(name + this.serviceSuffix, service);
      return this;
    },

    service: function(name) {
      var registryName = name + this.serviceSuffix;
      return this.getSingleton(registryName);
    },

    model: function(name) {
      return this.modelChannel.request(name);
    },

    buildService: function(Service) {
      return new Service(this);
    },

    buildConfigurator: function(Configurator) {
      return new Configurator(this);
    },

    createPageState: function(routeName, params) {
      var state = new PageState(params);

      this.channel.trigger('page:state:created', state);

      this
        .listenTo(state, 'change', function() {
          Backbone.history.trigger('state:' + routeName, state);
        })
        .listenTo(state, 'routeName', function(newName) {
          routeName = newName;
        });

      Backbone.history.trigger('state:' + routeName, state);
      Backbone.history.once('route', function() {
        state.stop();
        this.stopListening(state);
      }, this);

      return state;
    },

    onGlobalRoute: function(router, routeName, params) {
      if (router instanceof AKRouter) {
        // let the routing channel know that there is
        // a new route request
        this.executeController(routeName, this.createPageState(routeName, params));
      }
    },

    executeController: function(routeName, state) {
      this.routingChannel.trigger(routeName, state);
      return this;
    },

    _initChannel: function() {
      this.channelName = _.result(this, 'channelName') || 'global';
      this.channel     = _.result(this, 'channel') || Radio.channel(this.channelName);
      // grab the routing channel name from options
      this.routingChannelName = _.result(this, 'routingChannelName') || 'routing';
      // setup a routing channel from the name
      this.routingChannel = Radio.channel(this.routingChannelName);
      this.modelChannelName = _.result(this, 'modelChannel') || 'models';
      this.modelChannel = Radio.channel(this.modelChannelName);
    },

    request: function() {
      return this.channel.request.apply(this.channel, arguments);
    },

    execute: function() {
      this.channel.request.apply(this.channel, arguments);
      return this;
    },

    start: function(options) {
      this.trigger('start', options);
      this.channel.trigger('app:start', options);
      return this;
    }

  });

  return App;
});

